/**
 * @license
 * Copyright 2018-2021 Streamlit Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { colors, tailwindColors } from "../primitives/colors"

export default {
  ...colors,
  bgColor: colors.white,
  inputBgColor: colors.white,
  secondaryBg: tailwindColors.gray50,
  bodyText: colors.gray90,
  warning: tailwindColors.yellow800,
  warningBg: tailwindColors.yellow50,
  success: tailwindColors.green800,
  successBg: tailwindColors.green50,
  info: tailwindColors.blue800,
  infoBg: tailwindColors.blue50,
  danger: tailwindColors.red800,
  dangerBg: tailwindColors.red50,

  primary: "#ffc423",
  disabled: colors.gray40,
  sidebarBackgroundFrom: tailwindColors.gray50,
  sidebarBackgroundTo: colors.white,
  lightestGray: tailwindColors.gray100,
  lightGray: tailwindColors.gray200,
  gray: tailwindColors.gray400,
  darkGray: tailwindColors.gray500,
  red: tailwindColors.red500,
  blue: tailwindColors.blue500,
  green: tailwindColors.green500,
  yellow: tailwindColors.yellow500,
}
